import { BasicModel } from 'src/packages/mitsBasics';
import { IChecklistModule } from './checklist-module';

export interface IChecklistDependency extends BasicModel {
  /** A regEx needed to be matched if modules should be displayed */
  value: string;
  /** The ID of the module this dependency belongs to  */
  basic_module_id: number;
  /** Modules of this dependency / get displayed if value is matched */
  modules: IChecklistModule[];
  /** Deletes this module in backend */
  _destroy: boolean;
}

export function instanceOfIChecklistDependency(
  object: any
): object is IChecklistModule {
  return (
    'value' in object &&
    'modules' in object &&
    !('groups' in object) &&
    !('dep' in object)
  );
}
